/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

export enum AuthProviderType {
   OpenIdConnect = "openid-connect"
}

export interface AuthProviderClientConfig {
   type: AuthProviderType;
   friendlyName: string;
}

export interface AuthProviders {
   [authProviderName: string]: AuthProviderClientConfig;
}
